import { SUFFIX_CURRENCY_LOCALES } from "../tools/moneyFormats";

const layoutTrackingAndLocalization = function () {
  window.addEventListener("load", function () {
    var _learnq = window._learnq || [];

    function addedToCart() {
      fetch(`${window.location.origin}/cart.js`).then((res) =>
        res
          .clone()
          .json()
          .then((data) => {
            var cart = {
              total_price: data.total_price / 100,
              $value: data.total_price / 100,
              total_discount: data.total_discount,
              original_total_price: data.original_total_price / 100,
              items: data.items,
            };

            if (item !== "undefined") {
              cart = Object.assign(cart, item);
            }

            if (klAjax) {
              _learnq.push(["track", "Added to Cart", cart]);
              console.log("Added to Cart top line", cart);
              klAjax = false;
            }
          }),
      );
    }

    (function (ns, fetchFn) {
      ns.fetch = function () {
        const response = fetchFn.apply(this, arguments);
        response.then((res) => {
          if (`${window.location.origin}/cart/add.js`.includes(res.url) && res.url !== "") {
            addedToCart();
          }
        });
        return response;
      };
    })(window, window.fetch);

    var klAjax = true;
    var atcButtons = document.querySelectorAll(
      "form[action*='/cart/add'] button[type='submit'], .add-to-checkout, .sticky-form .add-to-cart",
    );

    for (var i = 0; i < atcButtons.length; i++) {
      atcButtons[i].addEventListener("click", function () {
        if (klAjax) {
          _learnq.push(["track", "Added to Cart", item]);
          console.log("Added to Cart", item);
          klAjax = false;
        }
      });
    }
  });

  function localizePrices() {
    const locale = window.Shopify && window.Shopify.locale;

    // Only suffix-currency languages (DE, AT, FR) render the symbol after the
    // amount. Keyed on the language code, never on the domain.
    if (!locale || !SUFFIX_CURRENCY_LOCALES.includes(locale.toLowerCase())) return;

    document.querySelectorAll(".localized-price").forEach((el) => {
      const text = el.textContent.trim();
      const match = text.match(/^([^\d\s]+)\s?([\d.,]+)$/);
      if (match) {
        const [, symbol, amount] = match;
        el.textContent = `${amount}${symbol}`;
      } else {
        const reverseMatch = text.match(/^([\d.,]+)\s?([^\d\s]+)$/);
        if (reverseMatch) {
          const [, amount, symbol] = reverseMatch;
          el.textContent = `${amount}${symbol}`;
        }
      }
    });
  }

  localizePrices();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        [...mutation.addedNodes].some(
          (node) => node.nodeType === 1 && node.querySelector?.(".localized-price"),
        )
      ) {
        localizePrices();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

export default layoutTrackingAndLocalization;
